import BlockType117Component from '@headlines/components/block/111-120/BlockType117.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType117: AdminBlockType = {
  component: BlockType117Component,
  attributes: AdminBlockTypeAttributes({}),
  articlesCount: 0,
};

export default AdminBlockType117;
